import styled from 'styled-components';

export const InputBox = styled.div`
  width: ${p => (p.width ? p.width : '')};
  position: relative;
  position: relative;
  input {
    width: 100%;
    background: #ffffff;
    border: 1px solid #9b9b9b;
    border-radius: 4px;
    outline: 0;
    height: 40px;
    font-family: 'Lato';
    font-size: 14px;
    font-weight: 400;
    color: #4a4a4a;
    padding: 0 15px;
    &:focus {
      border-color: #008cff;
    }
  }
  ${p =>
    p.hasRupeesSymbol &&
    `
        input{
            padding: 0 15px 0 55px;
        }
    `}
  .icCalendar {
    position: absolute;
    top: 11px;
    right: 15px;
  }
`;
export const Symbol = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background-color: #f2f2f2;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #9b9b9b;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
  font-weight: 700;
  color: #747474;
`;

export const Tooltip = styled.div`
  position: absolute;
  top: 52px;
  left: 0;
  z-index: 1;
  padding: 8px;
  border-radius: 4px;
  background-color: #000;
  color: #fff;
  width: 240px;
  &:before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    transform: rotate(45deg);
    top: -4px;
    left: 10px;
    background-color: #000;
  }
`;
export const TooltipHeading = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const TooltipHeadingText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 900;
`;
export const TooltipCloseBtn = styled.span`
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  &:before,
  &:after {
    position: absolute;
    left: 9px;
    content: ' ';
    height: 15px;
    width: 2px;
    top: 3px;
    background-color: #000;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const TooltipTxt = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
`;
